const StoredEntity = require('./stored-entity');

class RequestPackageStep extends StoredEntity {

	constructor(pkg) {
		super();
		// this._package = pkg;
		Object.defineProperty(this, '_package', {
			value: pkg,
			enumerable: false,
			writable: false,
			configurable: false
		});
		this.fields = [];	//{ id, rev }
		this._fields = [];	//loaded
		this.role = '';	//role - can be changed on init
		this.notifiedRolesOnClose = [];	//roles
		// this.recipient = '';	//sup-id if request_poultry_sup (???)
		// this.autoResponse = {
		// 	enabled: false,
		// 	days: 60,
		// 	response: 'reject'
		// };
		// this.allowsPartialAccept = false;
		this.autoResponseHours = 0;
		this.statusLabels = [];	//what shows in status for this step
	}

	getRole() {
		return this.role;
	}

	getFields() {
		return this.fields;
	}

	getFieldsLoaded() {
		if (this._fields.length < this.fields.length) throw new Error('fields are not loaded');
		return this._fields;
	}

	setFieldsLoaded(list) {
		this._fields = this.getFields().map(({ id, rev }) => {	//this way keeps the sorting
			return list.find(e => id === e.getId() && rev === e.getRev());
		});
	}

	getPackage() {
		return this._package;
	}

	toStorage() {
		let d = this._package.toStorage.call(this);
		return d;
	}

	fromStorage(d) {
		this._package.fromStorage.call(this, d);
	}

	getNotifiedRolesOnClose() {
		return this.notifiedRolesOnClose;
	}

	getStatusLabels() {
		return this.statusLabels;
	}

}


module.exports = RequestPackageStep;
